import React from 'react';

const Settings = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center p-4">
      <header className="text-center">
        <h1 className="text-4xl sm:text-5xl font-bold text-highlight font-sans">
          App <span className="text-accent">Settings</span>
        </h1>
        <p className="text-lg text-subtle mt-4">(Page content coming soon)</p>
      </header>
    </div>
  );
};

export default Settings;